class Bell extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.loadBellMenu.bind(this));
  }

  loadBellMenu() {
    const bellButton = document.querySelector("#bell");
    const addToCart = document.querySelector(".add2Cart_wishlist_wrapper");

    if (
      event.target !== document.querySelector(".menu-close") &&
      event.target !== document.querySelector(".menu-book") &&
      event.target !== document.querySelector(".menu-chat")
    ) {
      if (bellButton && bellButton.classList.contains("minimized")) {
        bellButton && bellButton.classList.remove("minimized");
        addToCart && addToCart.classList.add("pdp-bell");
        LiveChatWidget && LiveChatWidget.call("minimize");
      }
    }

    if (
      event.target == document.querySelector(".menu-close") ||
      event.target == document.querySelector(".menu-book")
    ) {
      bellButton && bellButton.classList.add("minimized");
      addToCart && addToCart.classList.remove("pdp-bell");
    }

    if (event.target == document.querySelector(".menu-chat")) {
      bellButton && bellButton.classList.add("minimized");
      addToCart && addToCart.classList.add("pdp-bell");

      document.querySelector("#chat-widget-container") &&
        document
          .querySelector("#chat-widget-container")
          .classList.add("bell-active");
      LiveChatWidget && LiveChatWidget.call("maximize");
    }
  }
}

LiveChatWidget && LiveChatWidget.on("visibility_changed", onVisibilityChanged);

var customSelect = document.querySelector(
  ".add2Cart_wishlist_wrapper .custom-select"
);

if (customSelect) {
  document.querySelector("#bell") &&
    document.querySelector("#bell").classList.add("maximized-sel");
  document.querySelector("#chat-widget-container") &&
    document
      .querySelector("#chat-widget-container")
      .classList.add("bell-active-sel");
}

window.addEventListener("scroll", function () {
  // hide when scrolling to end of page
  var viewportTop = window.pageYOffset;
  var viewportMiddle = window.pageYOffset + window.innerHeight;

  var elementTop =
    document.querySelector("#shopify-section-footer").getBoundingClientRect()
      .top - document.body.getBoundingClientRect().top;
  var elementBottom =
    elementTop +
    document.querySelector("#shopify-section-footer").getBoundingClientRect()
      .height;

  const isAtBottomOfPage =
    elementTop < viewportMiddle && elementBottom > viewportTop;

  if (isAtBottomOfPage) {
    document.querySelector("#bell").style.display = "none";
  } else {
    document.querySelector("#bell").style.display = "flex";
  }
});

function checkCookieBar() {
  var cookieMessage = document.querySelector(".cookie-message");

  document.documentElement.style.setProperty(
    "--cookie-bar-height",
    cookieMessage.offsetHeight + "px"
  );

  if (cookieMessage && cookieMessage.style.display === "none") {
    document.querySelector("#bell") &&
      document.querySelector("#bell").classList.remove("cookie-bar");
  } else {
    document.querySelector("#bell") &&
      document.querySelector("#bell").classList.add("cookie-bar");
  }
}

window.addEventListener("resize", checkCookieBar);
setTimeout(checkCookieBar, 200);

function onVisibilityChanged(data) {
  var bellButton = document.querySelector("#bell");
  var helpButton = document.querySelector("#chat-widget-container");
  var addToCart = document.querySelector(".add2Cart_wishlist_wrapper");
  var customSelect = document.querySelector(
    ".add2Cart_wishlist_wrapper .custom-select"
  );

  if (data.visibility == "minimized") {
    bellButton && bellButton.classList.remove("minimized");
    // setTimeout(function () {
    helpButton && helpButton.classList.remove("bell-active");
    // }, 250);
    addToCart && addToCart.classList.add("pdp-bell");
    if (customSelect) {
      document.querySelector("#chat-widget-container") &&
        document
          .querySelector("#chat-widget-container")
          .classList.add("bell-active-sel");
    }
  }

  if (data.visibility == "maximized") {
    bellButton && bellButton.classList.add("minimized");
    // setTimeout(function () {
    helpButton && helpButton.classList.add("bell-active");
    // }, 250);
    addToCart && addToCart.classList.remove("pdp-bell");
    if (customSelect) {
      document.querySelector("#chat-widget-container") &&
        document
          .querySelector("#chat-widget-container")
          .classList.add("bell-active-sel");
    }
  }
}

customElements.define("bell-menu", Bell);
